// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentUserIsGuest } from "@insite/client-framework/Store/Context/ContextSelectors";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Typography from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => ({
    currentUserIsGuest: getCurrentUserIsGuest(state),
    userName: state.context.session.userName,
});

const mapDispatchToProps = {
    signOut,
};

export interface SignOutStyles {
    noButton?: ButtonPresentationProps;
    yesButton?: ButtonPresentationProps;
}

const signOutStyles: SignOutStyles = {
    noButton: {
        color: "common.white",
    },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const SignOutWidget: React.FC<Props> = ({ userName, currentUserIsGuest, signOut, history }) => {
    React.useEffect(() => {
        if (!userName) {
            history.push("/SignIn");
        }
    });

    const signOutHandler = () => {
        signOut();
    };

    const redirectHandler = () => {
        history.push("/");
    };

    return (
        <StyledWrapper>
            <Typography variant="h4">Are you sure you would like to sign out?</Typography>
            <GridContainer>
                <GridItem width={[3, 2, 2, 2, 1]}>
                    <Button variant="secondary" onClick={signOutHandler} {...signOutStyles.yesButton}>
                        Yes
                    </Button>
                </GridItem>
                <GridItem width={[3, 2, 2, 2, 1]}>
                    <Button variant="primary" onClick={redirectHandler} {...signOutStyles.noButton}>
                        No
                    </Button>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(SignOutWidget)),
    definition: {
        group: "Testing",
        icon: "Row",
        fieldDefinitions: [],
    },
};

export default widgetModule;
